import { Form } from 'antd';
import { SelectUser } from 'components/shared/SelectUser';
import { Button } from 'components/UI';
import { Modal, ModalTitle } from 'components/UI/Modal/styled';
import { IProvider } from 'interfaces/graphql';
import React, { FC } from 'react';
import { useProvidersUpdateMutation } from 'utils/graphql/mutations/__generated__/providersUpdate';
import { useGetPsmUserOptions } from 'utils/hooks/useGetPsmUserOptions';

interface UpdatePsmModalProps {
  visible: boolean;
  onCancel: () => void;
  provider: IProvider;
}

interface UpdatePsmFormValues {
  partnerSuccessManagerId?: number;
}

export const UpdatePsmModal: FC<UpdatePsmModalProps> = ({ visible, onCancel, provider }) => {
  const { options, loading } = useGetPsmUserOptions({ skip: !visible });
  const [providersUpdate, { loading: saveLoading }] = useProvidersUpdateMutation();
  const [form] = Form.useForm<UpdatePsmFormValues>();

  const onFinish = async (values: UpdatePsmFormValues) => {
    await providersUpdate({
      variables: {
        input: {
          id: String(provider.id),
          attributes: {
            partnerSuccessManagerId: values.partnerSuccessManagerId ? String(values.partnerSuccessManagerId) : null,
          },
        },
      },
    });

    onCancel();
  };

  return (
    <Modal
      title={<ModalTitle>Partner success manager</ModalTitle>}
      open={visible}
      footer={false}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form
        form={form}
        name="updatePsmForm"
        onFinish={(values) => void onFinish(values)}
        layout="vertical"
        initialValues={{
          partnerSuccessManagerId: provider.partnerSuccessManager?.id,
        }}
      >
        <Form.Item label="Partner success manager:" className="m-b-xs" name="partnerSuccessManagerId">
          <SelectUser options={options} loading={loading} showSearch allowClear />
        </Form.Item>

        <div className="text-right">
          <Button className="m-r-sm" loading={saveLoading} onClick={onCancel}>
            Cancel
          </Button>

          <Button type="primary" htmlType="submit" loading={saveLoading}>
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
};
